// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"be38bf10","212":"4ba544dc","339":"299b972d","625":"43df4d5c"}[chunkId] + ".chunk.css";
};